import { TriangleAlert } from "lucide-react";
import { Box, Paper, Stack, Typography, useTheme } from "@mui/material";
import { Link, palette } from "@powerdiary/components-library/lib";
import { useEffect } from "react";

export default function BrowserNotSupported() {
    const theme = useTheme();

    useEffect(() => {
        document.title = "Browser Not Supported - Client Bookings Zanda";
    }, []);

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
            p={2}
            data-test-id="section_browser_not_supported"
        >
            <Paper elevation={4} sx={{ width: "600px" }}>
                <Stack spacing={3} p={4} alignItems="center">
                    <TriangleAlert
                        size={28}
                        strokeWidth={2}
                        color={theme.palette.primary.main}
                        data-test-id="icon_error"
                        aria-hidden
                    />
                    <Box display="flex" flexDirection="column" gap={1}>
                        <Typography variant="heading3" textAlign="center" data-test-id="text_error_title">
                            This website does not work in your browser version
                        </Typography>
                        <Typography
                            variant="paragraphMediumRegular"
                            textAlign="center"
                            data-test-id="text_error_subtitle"
                        >
                            To use this site, please upgrade to the latest version of your preferred browser.
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            background: palette.neutral[50],
                            borderRadius: 1,
                            padding: 2,
                        }}
                        data-test-id="section_browser_links"
                    >
                        <Typography variant="paragraphMediumBold" data-test-id="text_instructions_title">
                            Supported browsers
                        </Typography>
                        <ul style={{ margin: 0 }}>
                            <li>
                                <Link
                                    variant="paragraphMediumRegular"
                                    href="https://www.google.com/chrome/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-test-id="link_chrome"
                                >
                                    Google Chrome
                                </Link>
                            </li>
                            <li>
                                <Link
                                    variant="paragraphMediumRegular"
                                    href="https://www.microsoft.com/en-us/edge/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-test-id="link_edge"
                                >
                                    Microsoft Edge
                                </Link>
                            </li>
                            <li>
                                <Link
                                    variant="paragraphMediumRegular"
                                    href="https://www.mozilla.org/en-US/firefox/new/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-test-id="link_firefox"
                                >
                                    Mozilla Firefox
                                </Link>
                            </li>
                            <li>
                                <Typography variant="paragraphMediumRegular" data-test-id="text_safari">
                                    Latest version of Safari
                                </Typography>
                            </li>
                        </ul>
                    </Box>
                </Stack>
            </Paper>
        </Box>
    );
}
